import { get, post, put, del } from '@/api/request'

// 分页查询Banner列表
export function getBannerPage(params) {
  return get('/app/admin/banner/list', params)
}

// 获取Banner详情
export function getBannerDetail(id) {
  return get(`/app/admin/banner/${id}`)
}

// 创建Banner
export function createBanner(data) {
  return post('/app/admin/banner', data)
}

// 更新Banner
export function updateBanner(id, data) {
  return put(`/app/admin/banner/${id}`, data)
}

// 删除Banner
export function deleteBanner(id) {
  return del(`/app/admin/banner/${id}`)
}

// 更新Banner状态
export function updateBannerStatus(id, status) {
  return put(`/app/admin/banner/${id}/status?status=${status}`)
}
